module.exports = __webpack_public_path__ + "static/participate_frame-7df5c3dbc5ee84ddaea6a956c5a66cf0.png";